import { combineReducers } from 'redux'
import base from './base'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        base,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
